import { modals } from '@mantine/modals';
import { useDebtor } from 'app/Private/Clients/Detail/client-atom';
import { tKeys, useTranslation } from 'locales';
import { useCreateDebtorComment } from 'shared/hooks/use-create-debtor-comment';
import { useLoadReasons } from '~/modules/Settings/Variables/Reasons/api';
import { useBatchAction } from './common';
import { DirectContactPauseNote } from './DirectContactPauseNote';
import { submitDirectContactPause } from './submit-direct-contact-pause';

export function usePauseWithNote(): (invoiceIds: Array<string>) => void {
  const { t } = useTranslation();
  const debtor = useDebtor();
  const batchAction = useBatchAction();
  const { reasons } = useLoadReasons({ reasonType: 'pause' });
  const { createDebtorComment } = useCreateDebtorComment();

  return (invoiceIds: Array<string>) => {
    modals.closeAll();
    modals.open({
      title: t(tKeys.CLIENT.PAUSE),
      children: (
        <DirectContactPauseNote
          reasons={reasons.data.map(reason => ({ id: reason.id, name: reason.name }))}
          onSubmit={({ reason_id, end_at, comment }) => {
            modals.closeAll();
            submitDirectContactPause({
              invoiceIds,
              debtorId: debtor.id,
              reason_id,
              end_at,
              comment,
              createDebtorComment,
              batchAction,
            });
          }}
        />
      ),
    });
  };
}
